import { environment } from 'environments/environment';
import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { ApplicationComponent } from '../models/component-model';

@Injectable({
    providedIn: 'root'
})
export class ComponentsService {

    private API_COMPONENT_URL = environment.ipserver + 'AnA-backend/private/component';

    constructor(private http: HttpClient) { }

    /**
     * Method that obtains a list of components by calling applicatios rest service
     * @author Castor Transformación Digital - Fabio Oquendo
     * @since 2020-01-27
     * @return Observable with a json that contains a list of components
     */
    public getAllComponents(): Observable<any> {
        return this.http.get<any>(`${this.API_COMPONENT_URL}/findAll`);
    }

    /**
     * Method that obtains a list of components by calling applicatios rest service
     * @author Castor Transformación Digital - Fabio Oquendo
     * @since 2020-01-27
     * @return Observable with a json that contains a list of components
     */
     public getComponentsByApp(idApp: any): Observable<any> {
        const paramsForReq = new HttpParams()
        .set('applicationId', idApp);
        return this.http.get<any>(`${this.API_COMPONENT_URL}/findByApplication`, { params: paramsForReq });
    }

    /**
     * Method that obtains a component by calling applicatios rest service
     * @author Castor Transformación Digital - Fabio Oquendo
     * @since 2020-01-27
     * @param id: The component id
     * @return Observable with a json that contains a list of components
     */
    public getComponent(id: number): Observable<ApplicationComponent> {
        const httpHeaders = new HttpHeaders();
        httpHeaders.set('Content-Type', 'application/json');
        return this.http.post<ApplicationComponent>(`${this.API_COMPONENT_URL}/findById`, id, { headers: httpHeaders });
    }

    /**
     * Method that obtains a list of components by calling applicatios rest service
     * @author Castor Transformación Digital - Fabio Oquendo
     * @since 2020-01-27
     * @param component: The component
     * @return Observable with a json that contains a list of components
     */
    public addComponent(component: ApplicationComponent): Observable<any> {
        const httpHeaders = new HttpHeaders();
        const type = 'text' as 'json';
        httpHeaders.set('Content-Type', 'application/json');
        return this.http.post<any>(`${this.API_COMPONENT_URL}/addComponent`, component, { headers: httpHeaders, responseType: type });
    }

    /**
     * Method that obtains a list of components by calling applicatios rest service
     * @author Castor Transformación Digital - Fabio Oquendo
     * @since 2020-01-27
     * @param id: The component id
     * @return Observable with a json that contains a list of components
     */
    public removeComponent(id): Observable<any> {
        const paramsForPost = new HttpParams().set('id', id);
        const type = 'text' as 'json';
        return this.http.post<any>(`${this.API_COMPONENT_URL}/removeComponent`, id, { params: paramsForPost, responseType: type });
    }
}
